import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckoutPage from './pages/CheckoutPage';
import OrderSuccess from './pages/OrderSuccess';
import TemplatedMenuPage from './pages/TemplatedMenuPage';
import ShopByIdPage from './pages/ShopByIdPage';
import ShopTemplatedWrapper from './pages/ShopTemplatedWrapper';

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Switch>
        {/* Restaurant Legacy Routes */}
        <Route exact path="/restaurant/:restaurantId/:restaurantName?" component={TemplatedMenuPage} />
        <Route exact path="/shop/:shopId" component={ShopByIdPage} />
        
        {/* Slugged Routes */}
        <Route exact path="/:shopSlug/:shopCode" component={ShopTemplatedWrapper} />
        <Route path="/:shopSlug/:shopCode/checkout" component={CheckoutPage} />
        <Route path="/:shopSlug/:shopCode/order-success/:orderId" component={OrderSuccess} />

        {/* Backwards compatibility fallback routes */}
        <Route exact path="/:shopCode" component={ShopTemplatedWrapper} />
        <Route path="/:shopCode/checkout" component={CheckoutPage} />
        <Route path="/:shopCode/order-success/:orderId" component={OrderSuccess} />

        {/* Custom Domain Root & Direct Action Routes */}
        <Route exact path="/checkout" component={CheckoutPage} />
        <Route path="/order-success/:orderId" component={OrderSuccess} />
        <Route exact path="/" component={ShopTemplatedWrapper} />
      </Switch>
    </Router>
  );
}

export default App;
